import { render, staticRenderFns } from "./customPage.vue?vue&type=template&id=7af34c86&"
import script from "./customPage.vue?vue&type=script&lang=js&"
export * from "./customPage.vue?vue&type=script&lang=js&"
import style0 from "./customPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports